import { flow } from 'lodash';

import { NAME } from './onboarding.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
